import { PARDOT_COOKIE } from 'shared/constants/cookies'

const PARDOT_GATE = 'pardot_cookie_id_enabled'

/**
 * Pardot identifies just a little bit differently from our other providers
 *
 * Instead of looking for a hard cookie key (i.e. visitor_id), we instead need to grab the specific Pardot account id
 * from the embed and look for "visitor_id" + that account ID to pull the correct ID Pardot has associated with that contact
 */
const PardotIdentityProvider = {
  isEnabled: (gates:Record<string,any> = {}) => {
     return gates[PARDOT_GATE]
  },
  identify: (cookies: Record<string, any> = {}) => {
    return cookies[PARDOT_COOKIE]
  },
  getIntegrationContext: (cookies: Record<string, any> = {}) => {
    return {
      visitor_id: { cookie: cookies[PARDOT_COOKIE] }
    }
  }
}

export default PardotIdentityProvider
